<template>
  <common-page-layout class="profilelayout">
    <div v-if="profile">        
        <p v-if="profile.token">
          <label class="w3-text-grey">My Token</label> : <b>{{profile.token}}</b>  
        </p>
        <p v-if="profile.qr">          
          <span v-html="profile.qr"></span> 
        </p>
        
    </div>
  </common-page-layout>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  export default {
    name: "Profile",
    data() {
      return {
        msg: ""
      };
    },
    methods: {
      
    },
    beforeCreated() {},
    created: function() {},
    mounted() {},    
    computed: mapGetters(["person","profile"]),
    beforeDestroy() {},
    destroy() {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  /* Shared */
  
  .profilelayout {
    padding: 100px 0;
    text-align: center;
    /* margin: auto;
          width: 50%; */
    /* border: 3px solid green; */
    /* padding: 10px; */
  }  
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue